import { fromJS, List, Map, Set } from 'immutable';
import { isString } from '@/common/typeTests';
import { deepMerge, deepMergeNested } from 'nike-ui/src/common/immutable/merge';
import '../push-hybrid';

// kovertuje id v tvare "t:1234" na pure id, teda 1234
function pid(id) {
    return isString(id) ? parseInt(id.substring(id.indexOf(':') + 1), 10) : id;
}

function createBoxesHierarchy(db, boxStore, json, mergeFn, ns) {
    const bets = (json.bets || []).reduce((acc, bet) => {
        delete bet.boxIds;
        acc[bet.betId] = bet;
        return acc;
    }, {});
    const boxes = (json.boxes || []).reduce((acc, box) => {
        // delete box.betIds;
        // delete box.sportEventIds;
        // delete box.marketIds;
        acc[box.boxId] = box;
        return acc;
    }, {});
    const markets = (json.markets || []).reduce((acc, market) => {
        delete market.boxIds;
        acc[market.marketId] = market;
        return acc;
    }, {});
    const sportEvents = (json.sportEvents || []).reduce((acc, sportEvent) => {
        delete sportEvent.boxIds;
        acc[sportEvent.sportEventId] = sportEvent;
        return acc;
    }, {});

    return db
        .updateIn(ns.concat(['boxStore', boxStore, 'bets']), existing => mergeFn(existing, fromJS(bets)))
        .updateIn(ns.concat(['boxStore', boxStore, 'boxes']), existing => mergeFn(existing, fromJS(boxes)))
        .updateIn(ns.concat(['boxStore', boxStore, 'markets']), existing => mergeFn(existing, fromJS(markets)))
        .updateIn(ns.concat(['boxStore', boxStore, 'sportEvents']), existing => mergeFn(existing, fromJS(sportEvents)));
}

// zmaze stare live zapasy, ktore uz nie su potrebne
function clearUnusedLive(db, ns = []) {
    let liveSportEventIds = db.getIn(ns.concat(['boxStore']), Map()).reduce((acc, boxStore) => {
        return acc.concat(boxStore.get('liveSportEventIds', Set()));
    }, Set());
    // ak by bol detail vo vlastnom boxStore, nemuselo by sa to takto hackovat
    liveSportEventIds = liveSportEventIds.concat(
        db.getIn(ns.concat(['detail', 'data', 'box', 'liveSportEventIds']), List()).map(pid)
    );
    const oldLiveSportEventIds = db
        .getIn(ns.concat(['live']), Map())
        .keySeq()
        .toSet();
    return oldLiveSportEventIds
        .subtract(liveSportEventIds)
        .reduce((d, liveId) => d.deleteIn(ns.concat(['live', liveId])), db);
}

// vypocita turnaje na ktore sa treba subscribnut
function computeLiveInstances(db, boxStore, ns = []) {
    const liveSportEvents = db
        .getIn(ns.concat(['boxStore', boxStore, 'sportEvents']), Map())
        .filter(event => event.get('isLive', false));
    const liveTournamentIds = liveSportEvents.map(event => pid(event.get('tournamentId'))).toSet();
    const liveSportEventIds = liveSportEvents
        .keySeq()
        .map(pid)
        .toSet();
    return db
        .updateIn(ns.concat(['boxStore', boxStore, 'liveSportEventIds']), existing =>
            deepMerge(existing, liveSportEventIds)
        )
        .updateIn(ns.concat(['boxStore', boxStore, 'liveTournamentIds']), existing =>
            deepMerge(existing, liveTournamentIds)
        )
        .update(db => clearUnusedLive(db, ns));
}

export function replaceLoadedBoxes(db, boxStore, json, ns = []) {
    // pokial medzicasom prestal existovat boxStore (pouzivatel presiel na inu stranku ..) => ignorujeme update
    if (!db.getIn(ns.concat(['boxStore', boxStore]))) {
        console.warn(`Prisiel update boxov do neexistujuceho boxstoru! '${boxStore}' Volanie je ignorovane.`);
        return db;
    }
    let newDb = createBoxesHierarchy(db, boxStore, json, deepMerge, ns);
    newDb = computeLiveInstances(newDb, boxStore, ns);
    // console.log(Immutable.is(db, newDb));
    return newDb;
}

export function mergeLoadedBoxes(db, boxStore, json, ns = []) {
    // pokial medzicasom prestal existovat boxStore (pouzivatel presiel na inu stranku ..) => ignorujeme update
    if (!db.getIn(ns.concat(['boxStore', boxStore]))) {
        console.warn(`Prisiel update boxov do neexistujuceho boxstoru! '${boxStore}' Volanie je ignorovane.`);
        return db;
    }
    let newDb = createBoxesHierarchy(db, boxStore, json, deepMergeNested, ns);
    return computeLiveInstances(newDb, boxStore, ns);
}

export function setBoxesLoaders(db, boxIds, value, ns = []) {
    if (!boxIds) {
        return db;
    }
    const loadingMap = Map(boxIds.map(boxId => [boxId, value]));
    return db.updateIn(ns.concat(['loading', 'box']), Map(), boxLoadings => boxLoadings.merge(loadingMap));
}
